import React from 'react';
import { ModalBoundary } from '@atlassian/jira-modal/src/ui/modal-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { editSprintModalLoad } from './src/common/utils/performance-analytics/index.tsx';
import type { WithSuspenseProps } from './src/index.tsx';

const LazyEditSprintModal = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-edit-sprint-modal-relay" */ './src/index'),
);

const EditSprintModal = (props: WithSuspenseProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const onError = () => {
		fireOperationalAnalytics(createAnalyticsEvent({}), 'ui taskFail', {
			isRelay: true,
			task: 'loadEditSprintModal',
		});
		editSprintModalLoad.cancel();
	};

	return (
		<ModalBoundary id="edit-sprint-modal" packageName="editSprintModalRelay" onError={onError}>
			<Placeholder name="edit-sprint-modal-relay" fallback={null}>
				<LazyEditSprintModal {...props} />
			</Placeholder>
		</ModalBoundary>
	);
};

export default EditSprintModal;
